import React from 'react';
import { MessageSquare } from 'lucide-react';

interface FeedbackButtonProps {
  className?: string;
}

// Opens the mail client with a pre-filled MVP feedback template. Exported so the
// mobile nav drawer can trigger the same action (the floating button is desktop-only).
export function openFeedbackMail() {
  const subject = encodeURIComponent('OmniFlyer MVP Feedback');
  const body = encodeURIComponent(`Hi OmniFlyer team,

I'm providing feedback about the OmniFlyer MVP.

What I like:
[Share what you enjoy about the app]

What could be improved:
[Share suggestions for improvement]

Any bugs or issues:
[Describe any problems you encountered]

Best regards,
[Your name]`);

  window.open(`mailto:hello@omniflyer.com?subject=${subject}&body=${body}`, '_blank');
}

export const FeedbackButton: React.FC<FeedbackButtonProps> = ({ className = '' }) => {
  return (
    <button
      onClick={openFeedbackMail}
      className={`fixed bottom-6 right-6 z-50 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105 ${className}`}
      title="Share feedback about OmniFlyer MVP"
      aria-label="Share feedback about OmniFlyer MVP"
    >
      <div className="flex flex-col items-center">
        <MessageSquare className="h-6 w-6 mb-1" />
        <span className="text-xs font-bold">Feedback</span>
      </div>
    </button>
  );
};
